import React from "react";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {Spinner} from "..";
import PropTypes from 'prop-types'
import Waypoint from 'react-waypoint'
import {DropdownMenuContainer} from "./DropdownSelectorRenderer";

/**
 * Component that searches based on text, and returns structured values
 *
 * TODO - this has an awkward tension with a potential autocomplete/suggestion component,
 * In that component, the text input value would be more controlled
 */
export class SearchRender extends React.Component {

  static propTypes = {
    results: PropTypes.array,
    resultsHasMore: PropTypes.bool,
    resultsLoading: PropTypes.bool,
    resultsLoadingMore: PropTypes.bool,
    query: PropTypes.string,
    placeholder: PropTypes.string,
    renderOption: PropTypes.func,
    getKey: PropTypes.func,
    onSelected: PropTypes.func,
    onForceSelect: PropTypes.func,
    onQueryChange: PropTypes.func,
    getMore: PropTypes.func,
  }

  state = {
    isOpen: false,
    textFocused: false,
    hasLoaded: false,
    selectedIndex: 0,
    toggleRef: undefined
  }


  toggle = () => {
    if (!this.state.hasLoaded && !this.state.isOpen) {
      this.props.onQueryChange(this.props.query)
      this.setState({ hasLoaded: true})
    }

    this.setState({isOpen: !this.state.isOpen})
  }


  onChange = e => {
    this.props.onQueryChange(e.target.value)
  }


  setToggleRef = (ref) => {
    this.setState({toggleRef: ref})
  }

  onKeyDown = e => {
    const idx = this.state.selectedIndex;
    const results = this.props.results;
    if (e.key === 'ArrowUp') {
      this.setState({ selectedIndex: Math.max(0, idx - 1) })
    } else if (e.key === 'ArrowDown') {
      this.setState({ selectedIndex: Math.min(results.length - 1, idx + 1) })
    } else if (e.key === 'Escape') {
      this.toggle()
    } else if (e.key === 'Enter') {
      e.preventDefault() /* prevent outer form submission on selection */
      if (idx < results.length) {
        this.onSelected(results[idx])
      } else if (!results.length && this.props.onForceSelect) {
        this.props.onForceSelect(this.props.query)
      }
    }
  }

  onSelected = (option) => {
    this.setState({ isOpen: false })
    this.props.onSelected(option)
  }

  textFocus = () => this.setState({ textFocused: true })
  textBlur = () => this.setState({ textFocused: false })

  render() {
    const {
      results,
      resultsHasMore,
      resultsLoading,
      resultsLoadingMore,
      query,
      renderOption,
      getKey,
      onSelected,
      onForceSelect,
      onQueryChange,
      getMore,
      placeholder
    } = this.props
    const isOpen = this.state.isOpen || this.state.textFocused;
    return <Dropdown
      isOpen={isOpen}
      toggle={this.toggle}
    >
      <DropdownToggle
        tag="span"
        ref={this.setToggleRef}
      >
        <div className="input-group">
          <input type="text"
                 className="form-control"
                 placeholder={placeholder !== undefined ? placeholder : 'Search ...'}
                 onBlur={this.textBlur}
                 onFocus={this.textFocus}
                 onChange={this.onChange}
                 onKeyDown={this.onKeyDown}
                 value={query || ''} />
          <div className="input-group-append">
            <div className="input-group-text"><i className="far fa-search d-flex"></i></div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenuContainer
        isOpen={isOpen}
        tabIndex="0"
        toggleRef={this.state.toggleRef}
        className="overflow-auto w-100"
      >
        {
          resultsLoading &&
          <Spinner center timeout={0} size="sm"/>
        }
        {
          !resultsLoading && !results.length &&
          <DropdownItem disabled>
            <span className="text-muted">No Results</span>
            <div>{
              !!onForceSelect && <a className="clickable" onClick={() => onForceSelect(query)}>Add '{query}'?</a>
            }</div>
          </DropdownItem>
        }
        {
          !resultsLoading && results.map((result, i) => {
            return <DropdownItem
              active={this.state.selectedIndex === i}
              onClick={() => this.onSelected(result)}
              key={getKey(result)}>{renderOption(result)}</DropdownItem>
          })
        }
        {
          resultsLoadingMore &&
          <Spinner center timeout={0} size="sm"/>
        }
        {
          !resultsLoading && !resultsLoadingMore && resultsHasMore &&
          <Waypoint onEnter={getMore}/>
        }
        {
          !resultsLoading && !resultsLoadingMore && !resultsHasMore && results.length > 1 &&
          <DropdownItem disabled>
            <span className="text-muted">No More Results</span>
          </DropdownItem>
        }
      </DropdownMenuContainer>
    </Dropdown>
  }
}